import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {
	return createStyles({
		notification_container: {
			display: 'flex'
		},
		notification_content: {

		},
		notification_iconContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(2),
		},
		notification_icon: {
			fontSize: theme.spacing(4),
		},
		notification_title: {
			fontSize: theme.typography.subtitle1.fontSize,
			fontWeight: theme.typography.fontWeightBold,
		},
		notification_primaryMessage: {
			marginTop: theme.spacing(.5),
		},
		notification_secondaryMessage: {
			marginTop: theme.spacing(.5),
		},
	});
}

export default styles;
